/*
  FUNKITA お気に入り（localStorage 版） 2026-09-18 Claude
  - 保存: localStorage["fk_wishlist"] = ["handle1", "handle2", ...]
  - ボタン: [data-wishlist-toggle][data-handle]  → クリックで ON/OFF、is-active / aria-pressed を切替
  - ヘッダー: [data-wishlist-count] に件数、[data-wishlist-bubble] に is-visible
  - 一覧ページ: [data-wishlist-page] があれば /products/{handle}.js を取得して描画
  - 一覧の AJAX 読み込み（絞り込み・ページ送り）にも MutationObserver で追従
  - 統計: ハートON/OFFで GA4 add_to_wishlist / remove_from_wishlist（gtag）と Klaviyo「Added to Wishlist」「Removed from Wishlist」（klaviyo.push track）を送る。商品情報のみ
  - 2026-09-22: GA4 で商品別に集計できるよう、イベントパラメータ fk_item_id / fk_item_name / fk_item_brand / fk_item_type を追加
    （GA4 管理画面でイベントスコープのカスタムディメンションとして登録して使う）
*/
(function () {
  if (window.fkWishlist) return; // 二重読み込み防止
  var KEY = 'fk_wishlist';
  var MAX = 100;

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX))); } catch (e) {}
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var arr = read();
    var i = arr.indexOf(handle);
    if (i === -1) { arr.unshift(handle); } else { arr.splice(i, 1); }
    write(arr);
    syncAll();
    document.dispatchEvent(new CustomEvent('fk:wishlist:change', { detail: { handles: arr } }));
    return i === -1;
  }
  function remove(handle) {
    var arr = read().filter(function (h) { return h !== handle; });
    write(arr);
    syncAll();
    document.dispatchEvent(new CustomEvent('fk:wishlist:change', { detail: { handles: arr } }));
  }

  function syncButton(btn) {
    var on = has(btn.getAttribute('data-handle'));
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = btn.querySelector('[data-wishlist-label]');
    if (label) {
      var want = on ? label.getAttribute('data-on') : label.getAttribute('data-off');
      if (label.textContent !== want) label.textContent = want; // 同じ値の書き換えは避ける（MutationObserver のループ防止）
    }
    if (btn.classList.contains('fk-wish--card')) {
      btn.setAttribute('title', on ? 'お気に入りから外す' : 'お気に入りに追加');
    }
  }
  function syncHeader() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) { if (el.textContent !== String(n)) el.textContent = n; });
    document.querySelectorAll('[data-wishlist-bubble]').forEach(function (el) { el.classList.toggle('cart-link__bubble--visible', n > 0); });
  }
  function syncAll() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncButton);
    syncHeader();
  }

  // クリック（一覧カードはカード自体のクリック処理に食われないよう止める）
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    var added = toggle(handle);
    btn.classList.remove('is-pop');
    void btn.offsetWidth;
    if (added) btn.classList.add('is-pop');
    track(handle, added);
  }, true);

  // ===== 統計（GA4 + Klaviyo）。送るのは商品情報だけ。誰が、はGA4には送らない =====
  var infoCache = {};
  function productInfo(handle) {
    if (infoCache[handle]) return Promise.resolve(infoCache[handle]);
    return fetch(root() + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var info = p ? { handle: handle, title: p.title, price: Math.round(p.price / 100), url: location.origin + root() + '/products/' + handle, image: p.featured_image || '', vendor: p.vendor || '', type: p.type || '' } : { handle: handle, title: handle, price: 0, url: '', image: '', vendor: '', type: '' };
        infoCache[handle] = info;
        return info;
      })
      .catch(function () { return { handle: handle, title: handle, price: 0, url: '', image: '', vendor: '', type: '' }; });
  }
  function track(handle, added) {
    productInfo(handle).then(function (p) {
      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', added ? 'add_to_wishlist' : 'remove_from_wishlist', {
            currency: 'JPY', value: p.price,
            fk_item_id: p.handle, fk_item_name: p.title, fk_item_brand: p.vendor, fk_item_type: p.type,
            items: [{ item_id: p.handle, item_name: p.title, item_brand: p.vendor, item_category: p.type, price: p.price, quantity: 1 }]
          });
        }
      } catch (e) {}
      try {
        if (window.klaviyo && typeof window.klaviyo.push === 'function') {
          window.klaviyo.push(['track', added ? 'Added to Wishlist' : 'Removed from Wishlist', {
            ProductName: p.title, ProductHandle: p.handle, ProductURL: p.url, ImageURL: p.image, Brand: p.vendor, Price: p.price, $value: p.price,
            WishlistCount: read().length
          }]);
        }
      } catch (e) {}
    });
  }

  // ===== お気に入り一覧ページ =====
  function money(cents) {
    var fmt = (window.theme && theme.settings && theme.settings.moneyFormat) || '¥{{amount_no_decimals}}';
    var yen = Math.round(cents / 100);
    var s = yen.toLocaleString('ja-JP');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s);
  }
  function root() {
    var r = (window.theme && theme.routes && theme.routes.home) || '/';
    return r.replace(/\/$/, '');
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  function renderPage() {
    var wrap = document.querySelector('[data-wishlist-page]');
    if (!wrap) return;
    var grid = wrap.querySelector('[data-wishlist-grid]');
    var empty = wrap.querySelector('[data-wishlist-empty]');
    var handles = read();
    if (!handles.length) {
      grid.innerHTML = '';
      empty.hidden = false;
      return;
    }
    empty.hidden = true;
    grid.innerHTML = '<p class="fk-wl__loading">読み込み中…</p>';
    Promise.all(handles.map(function (h) {
      return fetch(root() + '/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = '';
      var gone = [];
      products.forEach(function (p, i) {
        var h = handles[i];
        if (!p) { gone.push(h); return; }
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '_540x$1$2') : '';
        var onSale = p.compare_at_price && p.compare_at_price > p.price;
        html += '<div class="grid__item grid-product fk-wl__item" data-handle="' + esc(h) + '">'
          + '<div class="grid-product__content">'
          + (p.available ? '' : '<div class="grid-product__tag grid-product__tag--sold-out">売り切れ</div>')
          + '<a href="' + root() + '/products/' + esc(h) + '" class="grid-product__link">'
          + '<div class="fk-wl__ratio">'
          + (img ? '<img class="fk-wl__img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" style="object-fit:cover;width:100%;height:100%;">' : '')
          + '</div>'
          + '<div class="grid-product__meta">'
          + '<div class="grid-product__title">' + esc(p.title) + '</div>'
          + '<div class="grid-product__price">'
          + (onSale ? '<span class="grid-product__price--original">' + money(p.compare_at_price) + '</span> ' : '')
          + money(p.price) + '</div>'
          + '</div></a>'
          + '<button type="button" class="fk-wl__remove" data-wishlist-remove="' + esc(h) + '">お気に入りから外す</button>'
          + '</div></div>';
      });
      if (gone.length) {
        // 商品が非公開・削除された分は静かに掃除
        var arr = read().filter(function (h) { return gone.indexOf(h) === -1; });
        write(arr); syncHeader();
      }
      grid.innerHTML = html || '';
      if (!html) { empty.hidden = false; }
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-remove]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation(); // テーマ側のカードクリック（商品ページへ遷移）を止める
    remove(b.getAttribute('data-wishlist-remove'));
    track(b.getAttribute('data-wishlist-remove'), false);
    var item = b.closest('.fk-wl__item');
    if (item) item.remove();
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (grid && empty && !grid.querySelector('.fk-wl__item')) empty.hidden = false;
  }, true);

  // AJAX で差し替わる一覧にも追従
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { syncAll(); break; }
    }
  });

  function init() {
    syncAll();
    renderPage();
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

  window.fkWishlist = { read: read, has: has, toggle: toggle, remove: remove, sync: syncAll };
})();
